import { IPhoto } from '~/client/graph'
import BaseModel from '~/client/src/shared/models/BaseModel'

import User from '../User'

export default class Photo extends BaseModel<IPhoto> {
  public id: string
  public url: string
  public thumbUrl: string
  public author: string
  public messageId: string
  public projectId: string

  public setAuthor(user: User) {
    if (user) {
      this.author = user.id
    }
  }
}
